// external
import React, { Component } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";

import { Button } from "components/ui/button";

import QRCode from "qrcode.react";

import { withTranslation } from "react-i18next";

import StepperEditor from "components/utils/StepperEditor/StepperEditor";
import SwitchOnOff from "components/common/tools/SwitchOnOff";
import { Input } from "../ui/input";

import google_auth_app from "resources/google_auth_app.png";
import authy_app from "resources/authy_app.png";

class FactorAuth extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: props.has2fa,
      deactivation: false,
      otp_token: "",
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { active, deactivation } = this.state;

    if (prevProps.has2fa !== this.props.has2fa) {
      this.setState({ active: this.props.has2fa });
    }

    if (prevState.active !== active) {
      this.props.onChange("activate", active);
      if (!active) this.setState({ otp_token: "" });

      if (!active && this.props.has2fa) {
        this.setState({ deactivation: true });
      } else if (active && deactivation) {
        this.setState({ deactivation: false });
      }
    }
  }

  onSubmit = (e) => {
    const { otp_token } = this.state;
    const { onSubmit } = this.props;

    e.preventDefault();
    onSubmit({ otp_token });
  };

  getSteps = () => {
    const { auth, t } = this.props;

    return [
      {
        label: <div className="mt-5">{t("2fa.choose_app")}</div>,
        label_node: (
          <div className="auth-apps">
            <img
              className="auth-app"
              title="Google Authenticator"
              src={google_auth_app}
            />
            <img className="auth-app" title="Authy" src={authy_app} />
          </div>
        ),
      },
      {
        label: <div className="mt-5">{t("2fa.scan_qr_code")}</div>,
        label_node: <QRCode value={auth.secretQR} />,
      },
      {
        label: <div className="mt-5">{t("2fa.confirm_code")}</div>,
        label_node: this.getOtpToken(),
      },
    ];
  };

  getOtpToken = () => {
    const { deactivation, otp_token } = this.state;
    const { t } = this.props;

    return (
      <div className="form-auth-container">
        <form
          onSubmit={this.onSubmit}
          className={`confirm-code ${deactivation ? "deactivation" : "activation"} flex flex-col items-center gap-5`}
        >
          <Input
            id="code"
            onChange={(e) => this.setState({ otp_token: e.target.value })}
            value={otp_token}
            className="text-foreground"
          />
          <Button type="submit" disabled={!otp_token}>
            {t("confirm")}
          </Button>
        </form>
      </div>
    );
  };

  renderDisconnect = () => {
    const { deactivation, otp_token } = this.state;
    const { onLogout, t } = this.props;

    const label = deactivation
      ? t("2fa.completed_deactivation")
      : t("2fa.completed_activation");

    return (
      <div
        className={`complete-and-disconnect ${deactivation ? "deactivation" : "activation"} flex flex-col gap-5`}
      >
        <h5>{label}</h5>
        <Button onClick={onLogout}>{t("2fa.finalize_and_reconnect")}</Button>
      </div>
    );
  };

  renderActivationCompleted = () => {
    const { auth, t } = this.props;

    return (
      <div>
        <p>{t("2fa.scratch_code_info_1")}</p>
        <p>{t("2fa.scratch_code_info_2")}</p>
        <ul>
          {auth.scratchCodes.map((code) => (
            <li key={`code_${code}`}>{code}</li>
          ))}
        </ul>
        {this.renderDisconnect()}
      </div>
    );
  };

  render() {
    const { active, deactivation } = this.state;
    const { auth, has2fa, t } = this.props;

    return (
      <div className="auth-container">
        <div className="editor-form-row editor-form-row-inline">
          <div className="editor-form-input">
            <SwitchOnOff
              name="factor-switch"
              disabled={auth.confirmed}
              onChange={(value) => this.setState({ active: value })}
              checked={active}
              size="sm"
            />
          </div>
          <div className="editor-form-label">
            {t("2fa.activate_double_authentication")}
          </div>
        </div>

        {!has2fa && active && auth.secretQR && !auth.confirmed && (
          <div className="editor-stepper-auth-container editor-stepper-non-linear editor-stepper-large p-5">
            <StepperEditor steps={this.getSteps()} nonLinear />
          </div>
        )}
        {active && !!auth.scratchCodes && auth.confirmed && (
          <div className="confirm-code-container">
            {this.renderActivationCompleted()}
          </div>
        )}
        {!active && !has2fa && auth.confirmed && <>{this.renderDisconnect()}</>}
        {!auth.confirmed && deactivation && (
          <div className="otp-token-deactivation">
            <p>{t("2fa.deactivation")}</p>
            {this.getOtpToken()}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { user } = state.fetchReducer;

  return {
    has2fa: user.data.has_2fa,
  };
};

FactorAuth.propTypes = {
  auth: PropTypes.object,
  has2fa: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(
  withTranslation("admin-profile")(FactorAuth),
);
